// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"Aam1nhdT"};